<nav class="breadcrumb" aria-label="Breadcrumb">
  <ol class="breadcrumb-list">
    <li class="breadcrumb-item">
      <a [routerLink]="['/dashboard']" class="breadcrumb-link">
        <mat-icon class="breadcrumb-icon">home</mat-icon>
        <span class="breadcrumb-label">Home</span>
      </a>
    </li>
    @for (breadcrumb of breadcrumbs; track breadcrumb.url; let isLast = $last) {
      <li class="breadcrumb-item">
        <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
        @if (isLast) {
          <span class="breadcrumb-current" aria-current="page">{{ breadcrumb.label }}</span>
        } @else {
          <a [routerLink]="breadcrumb.url" class="breadcrumb-link">
            {{ breadcrumb.label }}
          </a>
        }
      </li>
    }
  </ol>
</nav>
